import { Box, Table, TableBody, TableCell, TableContainer, TableRow, Typography } from "@mui/material";
import CustomIcon from "components/CustomIcon";
import MessageUpgrade from "components/Pro/Messages/MessageUpgrade";
import icons from "enums/icons";
import { useIntl } from "react-intl";
import { getAbilityIcon } from "utils";
import { BLURED_TABLE_DATA } from "components/Management/mocked-table-data/blured-table-data";

const ICReportRestrictedView = ({ isBoard, imageUrl }: { isBoard?: boolean; imageUrl?: string }) => {
    const intl = useIntl();

    if (!isBoard) {
        return (
            <Box
                sx={{
                    position: "relative",
                    display: "flex",
                    flex: 1,
                    backgroundImage: `url(${imageUrl})`,
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                    backgroundPosition: "top",
                    height: "58vh",
                    borderRadius: "11px",
                }}
            >
                <Box sx={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }}>
                    <MessageUpgrade title="pro.message.heading" icon={icons.proStar}>
                        <Typography>{intl.formatMessage({ id: "leadershipOverview.goPro.message" })}</Typography>
                    </MessageUpgrade>
                </Box>
            </Box>
        );
    }

    return (
        <Box position="relative">
            <TableContainer>
                <Table sx={{ tableLayout: "fixed", width: "100%", my: 1, p: 1 }}>
                    <colgroup>
                        {Array.from({ length: 9 }).map((_, i: number) => (
                            <col
                                key={i}
                                style={{
                                    width: i === 0 ? 200 : 100,
                                }}
                            />
                        ))}
                        <col style={{ width: 58 }} />
                    </colgroup>

                    <TableBody>
                        {BLURED_TABLE_DATA.map((row) => (
                            <TableRow key={row.member_id}>
                                <TableCell sx={{ py: 0.5 }}>
                                    <Box>
                                        <Typography variant="subtitle1">{row.member_name}</Typography>
                                        <Typography variant="subtitle1">{row.member_role}</Typography>
                                    </Box>
                                </TableCell>
                                {Array.from({ length: 8 }).map((_, i: number) => (
                                    <TableCell key={i} align="center" sx={{ py: 0.5 }}>
                                        <CustomIcon
                                            icon={getAbilityIcon(row.ability_scores[i])}
                                            sx={{ fontSize: 36 }}
                                        />
                                    </TableCell>
                                ))}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <Box
                sx={{
                    position: "absolute",
                    inset: 0,
                    backdropFilter: "blur(8px)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                <Box sx={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }}>
                    <MessageUpgrade title="pro.message.heading" icon={icons.proStar}>
                        <Typography>{intl.formatMessage({ id: "leadershipOverview.goPro.message" })}</Typography>
                    </MessageUpgrade>
                </Box>
            </Box>
        </Box>
    );
};

export default ICReportRestrictedView;
